import { Directive, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';

import { DashboardPillStateService } from '../dashboard-pill/dashboard-pill-state.service';
import { WidgetDataSource } from '../../models';
import { Comparison, WidgetGroup } from '../../providers/bridge-api/dashboard.service';

export enum MouseMovementState {
  ENTER = 'ENTER',
  LEAVE = 'LEAVE',
}

export interface PillHoverState {
  mouseState: MouseMovementState;
  entity: WidgetDataSource | Comparison | WidgetGroup;
}

@Directive({
  selector: '[appPillHover]',
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()',
  },
})
export class PillHoverDirective {
  readonly entity = input.required<WidgetDataSource | Comparison | WidgetGroup>({
    alias: 'appPillHover',
  });

  private pillStateService = inject(DashboardPillStateService);

  private readonly mouseEvent$ = new Subject<MouseMovementState>();

  constructor() {
    this.mouseEvent$
      .pipe(takeUntilDestroyed())
      .subscribe((mouseState) =>
        this.pillStateService.setPillHoverState({ entity: this.entity(), mouseState })
      );
  }

  onMouseEnter(): void {
    this.mouseEvent$.next(MouseMovementState.ENTER);
  }

  onMouseLeave(): void {
    this.mouseEvent$.next(MouseMovementState.LEAVE);
  }
}
